module.exports = __webpack_public_path__ + "static/media/card_bg_11.fb4844d0.png";